import "@sylviq/ui-react-web/styles.css";
import "@/shell/shell-tokens.css";
import "@/shell/shell-layout.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
